import loadable from '@loadable/component';

const RecentlyVisitedProductsLoader = loadable(() =>
  import(/* webpackChunkName: "secondary-content" */ './products')
);

export default RecentlyVisitedProductsLoader;
